import { writable } from "svelte/store";
import { spring } from "svelte/motion";



const { subscribe, update } = writable({
	mode:"",
	size:"",
	className: "",
	width: window.innerWidth,
	height: window.innerHeight,
	scrollY: window.pageYOffset,
});


function onResize() {
	const w = window.innerWidth;
	const mode = w < 920 ? "sp" : "pc";
	const size = w < 375 ? "s" : ( w < 1024 ? "m" :"l");
	update((state) => {
		return {
			...state,
			className: mode + " " + size,
			mode,
			size,
			width: w,
			height: window.innerHeight,
		};
	});
}


window.addEventListener("resize", onResize);
window.addEventListener("scroll", () => {
	update((state) => {
		return {
			...state,
			scrollY: window.pageYOffset,
		};
	});
});

function scroll(y = 0) {
	const scrollY = spring(window.pageYOffset);
	scrollY.subscribe((y) => {
		window.scrollTo({ top: y });
	});
	scrollY.set(y);
}

function resetScroll() {
	window.scrollTo(0,0);
}

onResize();

export default {
	subscribe,
	scroll,
	resetScroll,
};
